import { render } from "./QueStem4.vue?vue&type=template&id=2ef13264"
import script from "./QueStem4.vue?vue&type=script&lang=js"
export * from "./QueStem4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__